import { InventoryService } from "../services/InventoryService";

export class InventoryComponent extends HTMLElement {
    private inventory: string[] = [];
    private toggleInventory: boolean = false;
    private inventoryService: InventoryService;
    private shadow: ShadowRoot;

    public constructor() {
        super();
        this.shadow = this.attachShadow({ mode: "open" });
        this.inventoryService = new InventoryService();
        void this.loadInventory();
    }

    private async loadInventory(): Promise<void> {
        try {
            this.inventory = await this.inventoryService.getInventory();
            this.toggleInventory = await this.inventoryService.getToggleInventory();

            this.render();
        }
        catch (error) {
            console.error("Error loading inventory:", error);
        }
    }

    private render(): void {
        this.shadow.innerHTML = "";

        if (!this.toggleInventory) {
            return;
        }
        const inventoryModal: HTMLDivElement = document.createElement("div");
        const inventoryContainer: HTMLDivElement = document.createElement("div");
        const inventoryItemCon: HTMLDivElement = document.createElement("div");
        inventoryModal.classList.add("modal-bg");
        inventoryContainer.classList.add("inventory");
        inventoryItemCon.classList.add("item-con");
        inventoryModal.appendChild(inventoryContainer);

        const title: HTMLHeadingElement = document.createElement("h3");
        title.textContent = "Player Inventory";
        inventoryContainer.appendChild(title);
        inventoryContainer.appendChild(inventoryItemCon);

        if (this.inventory.length === 0) {
            const emptyMessage: HTMLDivElement = document.createElement("div");
            emptyMessage.classList.add("empty-message");
            emptyMessage.textContent = "Your inventory is empty.";
            inventoryContainer.appendChild(emptyMessage);
        }
        else {
            this.inventory.forEach(item => {
                const inventoryItem: HTMLDivElement = document.createElement("div");
                inventoryItem.classList.add("inventory-item");

                const img: HTMLImageElement = document.createElement("img");
                img.src = `/assets/img/rooms/items/${this.itemImages[item] ?? "default.png"}`;
                img.alt = item;
                img.title = item; // Tooltip
                img.classList.add("inventory-img");

                inventoryItem.appendChild(img);
                inventoryItem.addEventListener("click", () => this.onItemClick(item));
                inventoryContainer.appendChild(inventoryItem);
                inventoryItemCon.appendChild(inventoryItem);
            });
        }

        this.shadow.appendChild(inventoryModal);

        const style: HTMLStyleElement = document.createElement("style");
        style.textContent = `

        
    .modal-bg {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
}


    .inventory {
        font-family: "Orbitron", sans-serif;
        background: linear-gradient(145deg, #0a0f23, #1c143d);
        color: #cceeff;
        border: 2px solid #00eaff;
        border-radius: 15px;
        padding: 20px;
        max-width: 600px;
        width: 90%;
        max-height: 80vh;
        overflow-y: auto;
        box-shadow: 0 0 20px #00ffff;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 15px;
        text-align: center;
          position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    }

    h3 {
        margin: 0;
        font-size: 1.5rem;
        text-shadow: 0 0 6px #00ffff;
    }

    .item-con {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
        gap: 10px;
        width: 100%;
    }

    .inventory-item {
        padding: 10px;
        border-radius: 10px;
        color: #0712eb;
        text-shadow: 0 0 6px #0712eb;
        cursor: pointer;
        transition: 0.3s;
    }

    .inventory-item:hover {
        color: white;
    }

    .empty-message {
        font-style: italic;
        color: #999;
    }

    .inventory-img {
    width: 100%;
    height: auto;
    object-fit: contain;
    filter: drop-shadow(0 0 4px #00ffff);
    transition: transform 0.3s;
}

.inventory-item:hover .inventory-img {
    transform: scale(1.1);
}

`;

        this.shadow.appendChild(style);
    }

    private onItemClick(item: string): void {
        console.log(`Item clicked: ${item}`);
    }

    private itemImages: Record<string, string> = {
        "pass": "security-pass.png",
        "badge": "vip-badge.png",
        "quantumkey": "quantumkey.png",
        "EncryptedMemorychip": "EncryptedMemorychip.png",
        "SecretCodeLondon": "SecretCodeLondon.png",
        "data-catridge": "data-cardrige.png",
        "ai-sydney": "ai-sydney.png",
        "decoderring": "decoderring.png",
        "decoder-ring-fake": "decoderringfake.png",
        "floppydisk": "floppydisk.png",
    };
}
